import React, { useEffect, useRef } from "react";

const CampaignRiskLineChart = ({ campaignData = [] }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!window.Highcharts) {
      console.error("Highcharts is not loaded.");
      return;
    }

    const categories = campaignData.map((item) => item.campaignId.name);
    const riskScores = campaignData.map((item) => item.riskScore);

    const chart = window.Highcharts.chart(chartRef.current, {
      chart: {
        type: "areaspline",
        background: "#F5F5F5",
      },
      title: {
        text: "Simulations vs Risk Score",
        align: "left",
        style: {
          color: "#001628",
        },
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
        title: {
          text: "Campaign Name",
          style: {
            color: "#001628",
          },
        },
        labels: {
          style: {
            color: "#001628",
          },
        },
      },
      yAxis: {
        title: {
          text: "Risk Score",
          style: {
            color: "#001628",
          },
        },
        labels: {
          style: {
            color: "#001628",
          },
        },
        max: 100,
        min: 0,
      },
      tooltip: {
        shared: true,
        valueSuffix: " points",
        style: {
          color: "#001628",
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        areaspline: {
          fillOpacity: 0.5,
        },
        series: {
          marker: {
            enabled: true,
          },
        },
      },
      series: [
        {
          name: "Risk Score",
          data: riskScores,
          color: "rgba(0, 0, 0, 0.70)", // Line stroke
          lineWidth: 4,
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [[0, "rgba(0, 22, 40, 0.5)"], [1, "rgba(240, 30, 30, 0.5)"]],
          },
          shadow: {
            color: "rgba(96, 91, 255, 0.17)",
            offsetX: 0,
            offsetY: 4,
            width: 4,
          },
        },
      ],

      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    });

    return () => {
      chart.destroy();
    };
  }, [campaignData]);

  return (
    <div
      ref={chartRef}
      style={{ width: "100%", height: "400px", margin: "-60px auto" }}
    />
  );
};

export default CampaignRiskLineChart;
